function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import _t from "../models/identifier.js";
import { getByteLength as er } from "../util/string-utils.js";
import ti from "../models/push-token.js";
import { logger as N, IndexedDBAdapter as st } from "../../shared-lib/index.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import { User } from "../User/index.js";

var kt = /*#__PURE__*/function () {
  function kt(t, s) {
    _classCallCheck(this, kt);

    this.B = t, this.C = s, this.B = t, this.C = s;
  }

  _createClass(kt, [{
    key: "getUserId",
    value: function getUserId() {
      var t = this.C.tu(s.iu.su);
      if (null == t) return null;
      var i = t.eu,
          e = er(i);

      if (e > User.ur) {
        for (; e > User.ur;) {
          i = i.slice(0, i.length - 1), e = er(i);
        }

        t.eu = i, this.C.uu(s.iu.su, t);
      }

      return i;
    }
  }, {
    key: "ou",
    value: function ou(t) {
      var i = null == this.getUserId();
      this.C.uu(s.iu.su, new _t(t)), i && this.C.ru(t);
    }
  }, {
    key: "setCustomUserAttribute",
    value: function setCustomUserAttribute(t, s) {
      if (this.B.hu(t)) return N.info('Custom Attribute "' + t + '" is blocklisted, ignoring.'), !1;
      var i = {};
      return i[t] = s, this.nu(User.lu, i, !0);
    }
  }, {
    key: "nu",
    value: function nu(t, s) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var e = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var u = this.C.mu(this.getUserId(), t, s);
      var o = "",
          r = t,
          h = s;
      return i && (o = " custom", "object" == _typeof(s) && (r = Object.keys(s)[0], h = s[r], "object" == _typeof(h) && (h = JSON.stringify(h, null, 2)))), !e && u && N.info("Logged".concat(o, " attribute ").concat(r, " with value ").concat(h)), u;
    }
  }, {
    key: "An",
    value: function An(t, i, e, u, o) {
      this.nu("push_token", t, !1, !0), this.nu("custom_push_public_key", e, !1, !0), this.nu("custom_push_user_auth", u, !1, !0), this.nu("custom_push_vapid_public_key", o, !1, !0);
      var r = st.Ls.Fs,
          h = new st(r, N),
          n = new ti(t, i, e, u, o);
      this.C.Bt(s.gt.zn, n.bt()), h.setItem(r.Ms.cu, r.be, !0);
    }
  }, {
    key: "xn",
    value: function xn(t) {
      if (this.nu("push_token", null, !1, !0), this.nu("custom_push_public_key", null, !1, !0), this.nu("custom_push_user_auth", null, !1, !0), this.nu("custom_push_vapid_public_key", null, !1, !0), t) {
        var _t2 = st.Ls.Fs,
            i = new st(_t2, N);
        this.C.Bt(s.gt.zn, !1), i.setItem(_t2.Ms.cu, _t2.be, !1);
      }
    }
  }]);

  return kt;
}();

export { kt as default };